module.exports = __webpack_public_path__ + "googletravel-logo.png?dfaf2ec761f0279f5110598d72c09a64";